import { CSSProperties } from "react"

// スタイルの影響をPC側に及ぼさないため、CSSPropertyで記述する

export namespace CSS_PROPERTY {
  export const HEADER_HEIGHT = "4rem" as const
  export const TABLET_FONT_SIZE = "3rem" as const
  export const BORER_PROP = "2px solid #5f5f5f5f" as const
  export const BORER_RADIUS = "5px" as const
  export const BODY_TABLE_HEIGHT = "calc(100% - 15rem)" as const
  export const BODY_TABLE_BODY_ROW_HEIGHT = "calc(100% - 20rem)" as const
  export const BODY_TABLE_BUTTON_ROW_HEIGHT = "5rem" as const
  export const OK_COLOR = "#2fbdf2" as const
  export const WARN_COLOR = "#f2642f" as const
  export const BORER_PROPERTIES = {
    border: BORER_PROP,
    borderRadius: BORER_RADIUS,
  } as const
  export const GRID_FONT_SIZE = {
    小: "1rem",
    中: "1.5rem",
    大: "2rem",
  } as const

  export const WEATHER_COLOR: { [name: string]: string } = {
    sun: "#f2642f",
    cloud: "#1eb684",
    "cloud-rain": "#0078c0",
    snowflake: "#b32e92",
  } as const

  export const CARD = {
    SELECT_COLOR: "#93d4f5",
    SELECT_DANGER_COLOR: "#ffae90",
  } as const
}

export namespace HEADER {
  export const STYLE: CSSProperties = {
    height: CSS_PROPERTY.HEADER_HEIGHT,
    width: "100%",
    fontSize: "2rem",
    position: "absolute",
    verticalAlign: "middle",
    backgroundColor: "var(--kairos-main-color)",
    color: "white",
  }

  export const LOGO_MARK = {
    verticalAlign: "middle",
    margin: "6px 6px 12px 24px",
    height: "2rem",
  }
}
